import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import {
  ChangeDetectorRef,
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { distinctUntilChanged, map } from 'rxjs/operators';

// This directive is a candidate for extraction into utilities.
@UntilDestroy()
@Directive({
  selector: '[nodaResponsiveIf]',
  standalone: true,
})
export class ResponsiveDirective implements OnInit {
  @Input() public nodaResponsiveIf: string[];

  constructor(
    private templateRef: TemplateRef<HTMLElement>,
    private viewContainer: ViewContainerRef,
    private breakpointObserver: BreakpointObserver,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.subscribeToBreakpoints();
  }

  private subscribeToBreakpoints(): void {
    this.breakpointObserver
      .observe(this.nodaResponsiveIf)
      .pipe(
        map((state: BreakpointState) => state.matches),
        distinctUntilChanged(),
        untilDestroyed(this),
      )
      .subscribe((matches: boolean) => this.updateView(matches));
  }

  private updateView(matches: boolean): void {
    this.viewContainer.clear();
    if (matches) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
    this.changeDetectorRef.markForCheck();
  }
}
